import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, type Edge, type EdgeProps } from '@xyflow/react';
import type { HardwareEdge } from '../../types';

export interface SignalEdgeData extends Record<string, unknown> {
  ir: HardwareEdge;
  isTraced: boolean;
  isDimmed: boolean;
  isLocal: boolean;
}

type SignalFlowEdge = Edge<SignalEdgeData, 'signal'>;

export function SignalEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, markerEnd, data, selected }: EdgeProps<SignalFlowEdge>) {
  const [path, labelX, labelY] = getSmoothStepPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, borderRadius: 0, offset: 18 });
  const ir = data?.ir;
  const kind = ir?.kind ?? 'data';
  const isBus = kind === 'data' && (ir?.width ?? 1) > 1;
  const classes = ['signal-edge-path', `signal-${kind}`, data?.isTraced ? 'is-traced' : '', data?.isDimmed ? 'is-dimmed' : '', data?.isLocal ? 'is-local' : '', selected ? 'is-selected' : ''].filter(Boolean).join(' ');
  return <>
    {isBus && <BaseEdge id={`${id}-outline`} path={path} className={`${classes} signal-bus-outline`} />}
    <BaseEdge id={id} path={path} markerEnd={markerEnd} className={`${classes} ${isBus ? 'signal-bus-core' : 'signal-single-wire'}`} />
    <circle className={`signal-junction signal-${kind} ${data?.isTraced ? 'is-traced' : ''}`} cx={sourceX} cy={sourceY} r={isBus ? 4 : 3} />
    <circle className={`signal-junction signal-${kind} ${data?.isTraced ? 'is-traced' : ''}`} cx={targetX} cy={targetY} r={isBus ? 4 : 3} />
    {ir && <EdgeLabelRenderer>
      <div className={`signal-edge-label signal-${kind} ${data?.isTraced ? 'is-traced' : ''}`} style={{ transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)` }}>
        <span>{ir.signal}</span>{ir.width > 1 && <b>[{ir.width - 1}:0]</b>}
      </div>
    </EdgeLabelRenderer>}
  </>;
}

export const signalEdgeTypes = { signal: SignalEdge };
